module.exports = __webpack_public_path__ + "img/L_503_0.9a04129f.png";